import React, { useEffect, useState } from "react";

const VPstatus = ({
  textJson,
  isProgress,
  statusVp,
  activeBt,
  scrollIntoCordProofVP,
  scrollIntoCordSDRProofVP,
  scrollIntoSignatureVP,
}) => {
  const [inprogress, setInprogress] = useState("null");
  const [content, setContent] = useState();
  useEffect(() => {
    if (textJson) {
      const jsonVP = JSON.parse(textJson);
      const data = jsonVP.VerifiableCredential[0].credentialSubject;
      const { "@context": context, ...rest } = data;
      setContent(rest);
    }
  }, [textJson]);

  useEffect(() => {
    if (statusVp) {
      if (!isProgress) {
        setInprogress("second");
      }
      // const timeout2 = setTimeout(() => {
        setInprogress("third");
      // }, 4000);

      const timeout3 = setTimeout(() => {
        setInprogress("null");
      }, 4000);


      // Clear the timeouts to prevent memory leaks
      return () => {
        // clearTimeout(timeout2);
        clearTimeout(timeout3);
      };
    }
  }, [statusVp, isProgress]);

  return (
    <>
      {/* <span>
        <div
          className={`verify-body mt-2 ${
            statusVp && activeBt === "Ed25519Signature2020" ? "active" : ""
          } ${statusVp ? "" : " disabled"}`}
          onClick={() => {
            if (statusVp) {
              scrollIntoSignatureVP();
            }
          }}
        >
          {!isProgress && !statusVp ? (
            <img
              className={`success-svg sign`}
              src="successdis.svg"
              alt="Loader"
            ></img>
          ) : isProgress && statusVp === undefined ? (
            <div className="loaderico">
              <div
                className="spinner-border spinner-border-sm loading-spin"
                role="status"
              >
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : statusVp ? (
            statusVp["Ed25519Signature2020"]?.isValid && !isProgress ? (
              <span className="divsvg">
                <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"> <circle className="checkmark__circle" cx="23" cy="23" r="23" fill="none"/> <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                </svg>
                </span>
            ) : (
              <img
                className={`success-svg sign`}
                src="error.svg"
                alt="Loader"
              ></img>
            )
          ) : null}
          <div className="sign-body">
            <p className="d-flex flex-column">
              Issuer verified{" "}
              {statusVp &&
              !isProgress &&
              !statusVp["Ed25519Signature2020"].isValid &&
              statusVp["Ed25519Signature2020"].message ? (
                <span className="errortxt">
                  {statusVp["Ed25519Signature2020"].message}
                </span>
              ) : null}
            </p>
          </div>
        </div>
        {/* {!statusVc["Ed25519Signature2020"].verified &&
        statusVc["Ed25519Signature2020"].msg ? (
          <span className="errortxt">
            {statusVc["Ed25519Signature2020"].msg}
          </span>
        ) : null} */}
     {/* </span> */}
      <span>
        <div
          className={`verify-body  mt-2 ${
            activeBt === "CordProof" ? "active" : ""
          }${statusVp && inprogress !== "second" ? "" : " disabled"}`}
          onClick={() => {
            if (statusVp) {
              scrollIntoCordProofVP();
            }
          }}
        >
          {!statusVp ? (
                <div className="loaderico">
                <div
                  className="spinner-border spinner-border-sm loading-spin"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
          ) : inprogress === "second" && statusVp ? (
            <div className="loaderico">
              <div
                className="spinner-border spinner-border-sm loading-spin"
                role="status"
              >
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : statusVp && inprogress !== "second" ? (
            statusVp["CordProof2025"]?.isValid ? (
              <span className="divsvg">
              <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"> <circle className="checkmark__circle" cx="23" cy="23" r="23" fill="none"/> <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
              </svg>
              </span>
            ) : (
              <img
                className={`success-svg sign`}
                src="error.svg"
                alt="Loader"
              ></img>
            )
          ) : null}

          <div className="sign-body">
            <p className="d-flex flex-column">
              Cord validation{" "}
              {statusVp &&
              inprogress !== "second" &&
              !statusVp["CordProof2025"].isValid &&
              statusVp["CordProof2025"].message ? (
                <span className="errortxt">
                  {statusVp["CordProof2025"].message}
                </span>
              ) : null}
            </p>
          </div>
        </div>
      </span>
      {/* CordSDRProof2025 */}
      <span>
        <div>
          <div
            className={`verify-body mt-1 ${
              activeBt === "CordSDRProof" ? "active" : ""
            }${
              statusVp && inprogress !== "second" && inprogress !== "third"
                ? ""
                : " disabled"
            }`}
            onClick={() => {
              if (statusVp) {
                scrollIntoCordSDRProofVP();
              }
            }}
          >
            {!statusVp ? (
              <img
                className={`success-svg sign`}
                src="successdis.svg"
                alt="Loader"
              ></img>
            ) : inprogress === "third" && statusVp ? (
              <div className="loaderico">
                <div
                  className="spinner-border spinner-border-sm loading-spin"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : statusVp && inprogress === "null" ? (
              statusVp["CordSDRProof2025"]?.isValid ? (
                <span className="divsvg">
                <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"> <circle className="checkmark__circle" cx="23" cy="23" r="23" fill="none"/> <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                </svg>
                </span>
              ) : (
                <img
                  className={`success-svg sign`}
                  src="error.svg"
                  alt="Loader"
                ></img>
              )
            ) : (
              <img
                className={`success-svg sign`}
                src="successdis.svg"
                alt="Loader"
              ></img>
            )}

            <div className="sign-body ">
              <p className="d-flex flex-column">
                Content proof
              {console.log("statusVp",statusVp)}
                {statusVp &&
                inprogress !== "null" && statusVp["CordSDRProof2025"] &&
                !statusVp["CordSDRProof2025"].isValid &&
                statusVp["CordSDRProof2025"].message ? (
                  <span className="errortxt">
                    {statusVp["CordSDRProof2025"].message}
                  </span>
                ) : null}
              </p>
            </div>
          </div>
          {content && statusVp && inprogress === "null" ? (
            <div className="d-flex conentPal">
              <div>
                <p className="contentSty mb-0">Requested Content</p>
                {Object.entries(content).map(([key, value]) => {
                  return (
                    <div key={key}>
                      {typeof value === 'string' && !value.startsWith("data:image") ? (
                        <>
                          <p className="contentSty mb-0 keyVal">{[key]}:</p>
                          <p className="contentval mb-1">{[value.toString()]}</p>
                        </>
                      ) : typeof value === 'number'  ? (
                        <>
                        <p className="contentSty mb-0 keyVal">{[key]}:</p>
                        <p className="contentval mb-1">{[value.toString()]}</p>
                      </>
                      ):typeof value === 'object' ? 
                      (   <>
                        <p className="contentSty mb-0 keyVal">{[key]}:</p>
                        <p className="contentval mb-1">{[JSON.stringify(value)]}</p>
                      </>):(<>
                        <p className="contentSty mb-0">{[key]}:</p>
                        <img
                          className="photoContent"
                          src={value}
                          alt="Loader"
                        ></img>
                      </>)}
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null}
        </div>
      </span>
    </>
  );
};

export default VPstatus;
